import httpService from '@Utils/httpService';

const baseUrl = 'api/dashboard/CoatingAnalysis';

export default {
    get(params) {
         return httpService.post({
                   url: `${baseUrl}/TypeHead`,
                   data: params,
               });
       
    },
    getFilters(params) {
        return httpService.get({
            url: `${baseUrl}/filters`,
            params
        });
    },
    update(data) {
        return httpService.put({
            url: `${baseUrl}/${data.id}`,
            data,
        });
    },
    updateMultiple(data) {
        return httpService.put({
            url: `${baseUrl}/updateMultiple`,
            data,
        });
    },
    accept(id) {
        return httpService.post({
            url: `${baseUrl}/accept/${id}`,
        });
    },
    reject(id) {
        return httpService.post({
            url: `${baseUrl}/reject/${id}`,
        });
    },
    delete(id) {
        return httpService.delete({
            url: `${baseUrl}/${id}`,
        });
    },
    deleteMultiple(data) {
        return httpService.delete({
            url: `${baseUrl}/deleteMultiple`,
            data,
        });
    },
    getProcessingCount(facilityId) {
        return httpService.get({
            url: `${baseUrl}/processingCount/${facilityId}`,
        });
    },
    generateReport(id) {
        return httpService.get({
            url: `${baseUrl}/report/${id}`,
        });
    },
        getById(id) {
        return httpService.get({
            url: `${baseUrl}/${id}`,
        });
    },
    add(data) {
        return httpService.post({
            url: `${baseUrl}`,
            data,
        });
    },
};

